import { DEFAULT_SITE } from "../../../../constants";
import { changeTimeFormat } from "../../helpers";

export const logSheetClearSuggestion = ({ loadSuggestion = null, formik, user, equipmentDetail }) => {
  if (loadSuggestion) {
    loadSuggestion(null);
  }
  formik.setValues({
    ...formik.values,
    site: user.site ?? DEFAULT_SITE,
    approverId: user.user,
    approverUserName: user.name,
    materialNumber: "",
    serialNumber: formik.values.serialNumber || (equipmentDetail ? equipmentDetail?.serialNumber : null),
    equipmentId: formik.values.equipmentId || (equipmentDetail ? equipmentDetail?.equipmentId : null),
    equipmentModel: equipmentDetail ? equipmentDetail?.equipmentModel : "",
    equipmentNickName: equipmentDetail
      ? equipmentDetail?.equipmentNickName ?? equipmentDetail?.equipmentDetails?.equipmentNickName ?? ""
      : "",
    inventoryId: equipmentDetail ? equipmentDetail?.inventoryId : "",
    actionTime:
      formik.values.actionTime ||
      (equipmentDetail
        ? equipmentDetail?.actionTime
          ? equipmentDetail?.actionTime
          : changeTimeFormat(new Date())
        : changeTimeFormat(new Date())),
    instrumentDetails: {
      configurationBaseline: equipmentDetail ? equipmentDetail?.configurationBaseline || null : null,
      instrumentGxPStatus: equipmentDetail ? equipmentDetail?.instrumentGxPStatus || null : null,
      equipmentNickName: equipmentDetail ? equipmentDetail?.equipmentNickName || null : null,
      responsiblePerson: equipmentDetail ? equipmentDetail?.responsiblePerson || null : null,
      manufacturer: equipmentDetail ? equipmentDetail?.manufacturer || null : null,
      softwareVersion: equipmentDetail ? equipmentDetail?.softwareVersion || null : null,
      location: equipmentDetail ? equipmentDetail?.location || null : null,
      responsibleProxy: equipmentDetail ? equipmentDetail?.responsibleProxy || null : null
    }
  });
};

/**
 * Get cluster values from formik or equipmentDetail
 * @param {object} formik formik object
 * @param {object} equipmentDetail  equipmentDetail
 * @param {function} translator function to translate status
 * @param {string} formikKeyName key name from formik
 * @param {string} eqDetKeyName  key name from equipmentDetail
 * @returns {{key: string, newValue?: {key:string, value:string}, shouldBePublished?: boolean}|null }
 */
const getClusterValues = ({ formik, equipmentDetail, arrayVals, formikKeyName, eqDetKeyName, searchBy }) => {
  return formik.values[`${formikKeyName}Cluster`].key || formik.values[`${formikKeyName}Cluster`].newValue
    ? formik.values[`${formikKeyName}Cluster`]
    : equipmentDetail
    ? {
        key: arrayVals.find((item) => item[searchBy] === equipmentDetail[eqDetKeyName])?.key || null,
        value: arrayVals.find((item) => item[searchBy] === equipmentDetail[eqDetKeyName])?.value || null
      }
    : null;
};

export const logSheetClusterClear = ({ formik, gxpReadys, systemStatuses, user, equipmentDetail }) => {
  formik.setValues({
    ...formik.values,
    actionTime:
      formik.values.actionTime ||
      (equipmentDetail
        ? equipmentDetail?.actionTime
          ? equipmentDetail?.actionTime
          : changeTimeFormat(new Date())
        : changeTimeFormat(new Date())),
    approverId: user.user,
    approverUserName: user.name,
    equipmentId: formik.values.equipmentId || (equipmentDetail ? equipmentDetail?.equipmentId : null),
    equipmentModel: equipmentDetail ? equipmentDetail?.equipmentModel : "",
    equipmentNickName: equipmentDetail
      ? equipmentDetail?.equipmentNickName ?? equipmentDetail?.equipmentDetails?.equipmentNickName ?? ""
      : "",
    instrumentDetails: {
      configurationBaseline: equipmentDetail ? equipmentDetail?.configurationBaseline || null : null,
      instrumentGxPStatus: equipmentDetail ? equipmentDetail?.instrumentGxPStatus || null : null,
      equipmentNickName: equipmentDetail ? equipmentDetail?.equipmentNickName || null : null,
      responsiblePerson: equipmentDetail ? equipmentDetail?.responsiblePerson || null : null,
      manufacturer: equipmentDetail ? equipmentDetail?.manufacturer || null : null,
      softwareVersion: equipmentDetail ? equipmentDetail?.softwareVersion || null : null,
      location: equipmentDetail ? equipmentDetail?.location || null : null,
      responsibleProxy: equipmentDetail ? equipmentDetail?.responsibleProxy || null : null
    },
    inventoryId: equipmentDetail ? equipmentDetail?.inventoryId : "",
    isClusterQualificationChanged: false,
    materialNumber: "",

    gxpReadyCluster: getClusterValues({
      formik,
      equipmentDetail,
      arrayVals: gxpReadys,
      formikKeyName: "gxpReady",
      eqDetKeyName: "qualificationStatus",
      searchBy: "key"
    }),
    systemStatusCluster: getClusterValues({
      formik,
      equipmentDetail,
      arrayVals: systemStatuses,
      formikKeyName: "systemStatus",
      eqDetKeyName: "systemStatus",
      searchBy: "value"
    }),
    clusterQualificationStatus: equipmentDetail ? equipmentDetail?.qualificationStatus || null : null,
    clusterSystemStatus: equipmentDetail ? equipmentDetail?.systemStatus || null : null,
    serialNumber: formik.values.serialNumber || (equipmentDetail ? equipmentDetail?.serialNumber : null),
    site: user.site ?? DEFAULT_SITE
  });
};
